import React from 'react'
import { GetTagInstructionsContainer, CodeBlock } from '../../Instructions.styled'
import { Trans, useTranslation } from 'react-i18next'
import { StyledLink } from 'Components/Elements/Link/Link.styled'
import { BulletLine } from '../../../elements/BulletLine'
import { zendeskLinks } from 'Consts/links/models/zendesk'
import * as codeFunctions from '../../utils'
import { CopyTextButton } from '@clickcease/cc-client-components-lib'
import {
  CodeBlockWrapper,
  ForMoreDetails,
  GoogleTagManagerManualText,
  InstructionsTitle,
} from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/GoogleTagManagerManual/GoogleTagManagerManual.styled'
import { useZendeskChat } from 'Hooks/zendesk/useZendeskChat'
import { HelpCenterRedirect } from 'Features/HelpCenterRedirect/HelpCenterRedirect'

export const GoogleTagManagerManualMethod = ({
  tagUrl,
  domainHashCode,
  noMargin,
}: {
  tagUrl: string
  domainHashCode: string
  noMargin?: boolean
}) => {
  const { t } = useTranslation('domainManagement')
  const { openChat } = useZendeskChat()

  const code = codeFunctions.generateCodeScript(tagUrl, domainHashCode)
  const noScriptUrl = codeFunctions.generateGtmNoScriptUrl(tagUrl, domainHashCode)

  return (
    <GetTagInstructionsContainer noMargin={noMargin}>
      <GoogleTagManagerManualText>
        {t('get_tag_modal.gtm_manual_steps.title')}
      </GoogleTagManagerManualText>
      <BulletLine>1. {t('get_tag_modal.gtm_manual_steps.step_1')}</BulletLine>
      <BulletLine>2. {t('get_tag_modal.gtm_manual_steps.step_2')}</BulletLine>
      <BulletLine>3. {t('get_tag_modal.gtm_manual_steps.step_3')}</BulletLine>
      <BulletLine>4. {t('get_tag_modal.gtm_manual_steps.step_4')}</BulletLine>
      <BulletLine>5. {t('get_tag_modal.gtm_manual_steps.step_5')}</BulletLine>
      <BulletLine>6. {t('get_tag_modal.gtm_manual_steps.step_6')}</BulletLine>

      {/* Code blocks */}
      <CodeBlockWrapper>
        <InstructionsTitle>{t('get_tag_modal.gtm_manual_steps.invocation_tag')}</InstructionsTitle>
        <CodeBlock>{code}</CodeBlock>
        <CopyTextButton value={code} buttonText={t('get_tag_modal.copy-code')} />
      </CodeBlockWrapper>
      <CodeBlockWrapper>
        <InstructionsTitle>{t('get_tag_modal.gtm_manual_steps.no_script_tag')}</InstructionsTitle>
        <CodeBlock>{noScriptUrl}</CodeBlock>
        <CopyTextButton value={noScriptUrl} buttonText={t('get_tag_modal.copy-code')} />
      </CodeBlockWrapper>
      <ForMoreDetails>
        <Trans ns="domainManagement" i18nKey="get_tag_modal.gtm_manual_steps.for_more_details">
          For more detailed instructions or if you need further assistance, please visit our or
          <HelpCenterRedirect
            text="help center"
            article={zendeskLinks.howToAddCheqToWebsiteWithGTM}
          />
          or
          <StyledLink onClick={() => openChat()}>contact support.</StyledLink>
        </Trans>
      </ForMoreDetails>
    </GetTagInstructionsContainer>
  )
}
